import { render, staticRenderFns } from "./freQuent.vue?vue&type=template&id=0fc93e98&"
import script from "./freQuent.vue?vue&type=script&lang=js&"
export * from "./freQuent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports